var company = {};
module['exports'] = company;
company.suffix = require("./suffix");
company.name = require("./name");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pt_BR/company/index.js
 ** module id = 876
 ** module chunks = 0
 **/